// The session-history rail, supplied to `FocusFrame` out of band.
//
// `FocusFrame` mints the `.loom-focus` root on EVERY Focus screen (13 call
// sites across the wizard, chat, refine and implement), so a rail passed as a
// prop would have to be threaded through all of them. It rides a context
// instead: `FocusPage` provides the node once, per project, and every frame
// rendered underneath picks it up. A `null` value — the default, and what
// `/focus` (no project) provides — means no drawer and no toggle, so a screen
// outside a project renders exactly as it does without this file.
//
// Its own module rather than `ui.tsx` so `FocusSessionRail` can import the ui
// primitives without an import cycle.

import { createContext, useContext, type ReactNode } from "react";

const FocusRailContext = createContext<ReactNode>(null);

export const FocusRailProvider = ({
  rail,
  children,
}: {
  readonly rail: ReactNode;
  readonly children: ReactNode;
}) => <FocusRailContext.Provider value={rail}>{children}</FocusRailContext.Provider>;

/** The rail node for the surrounding project, or `null` when there is none. */
export const useFocusRail = (): ReactNode => useContext(FocusRailContext);
